<template>
  <div class="tc-panel grid">
    <div class="grid-header">
      <qc-checkbox v-model="selectAllButton.all" :indeterminate="selectAllButton.some" @input="changeCheckAll">
        {{$t('core.select_all')}}
      </qc-checkbox>
    </div>
    <div class="grid-body" :style="gridBodyStyle" v-if="innerList.length"
         @click="onEventActions" v-click-outside="onClickOutside">
      <div class="tc-g" v-show="!loading" ref="grid">
        <div class="tc-g-u-1-8 finder-item" v-for="(item,index) in innerList" :key="item.id"
          :title="item.name + (item.isDir?'':' ('+item.sizeText+')')" :draggable="false"
          @contextmenu.prevent.stop="itemRightClick(item, index, $event)" @dblclick="itemDblClick(item, index, $event)"
          @mouseover="hoverIndex=index" @mouseleave="hoverIndex=-1">
          <div class="grid-file" :class="{'active': innerSelectedMap[item.name]}">
            <img v-if="item.previewUrl && item.previewUrl.startsWith('error')" class="cos-icon--56 previewUrl"
              src="~@/assets/images/image-error.png" />
            <div v-else-if="item.previewUrl" class="cos-icon--56 previewUrl"
              :style="{backgroundImage:'url('+item.previewUrl+')'}">
            </div>
            <div v-else class="cos-icon--56" :class="item.isDir?'document':item.icon"></div>
            <p class="grid-file__title">
              <span class="grid-file__title--txt text-overflow">{{item.name}}</span>
            </p>
            <div class="icon-more" v-show="innerSelectedMap[item.name]||hoverIndex===index" :data-index="index"
              data-action="dropmenu">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-body blank" :style="gridBodyStyle" v-else>
      <div class="text-center" v-if="loading">
        <template v-if="searchStatus.isSearching">
          <div class="blank-img search"></div>
          <div class="blank-title">{{$t('core.state_map.doing[0]',{action:$t('core.search')})}}...
          </div>
        </template>
        <template v-else>
          <qc-icon type="loading"></qc-icon>
          <span>{{$t('core.loading')}}</span>
        </template>
      </div>
      <template v-else>
        <template v-if="!hasAuthority">
          <div class="blank-img no-access"></div>
          <div class="blank-title">{{$t('cos.tips.no_access_to_bucket')}}</div>
          <div class="blank-help">{{$t('cos.tips.concat_root_to_auth')}}</div>
        </template>
        <template v-else>
          <template v-if="searchStatus.isSearchDone">
            <div class="blank-img lost"></div>
            <div class="blank-title">{{$t('cos.tips.no_result_found')}}</div>
            <div class="blank-help">{{$t('cos.tips.try_diffrent_keyword')}}</div>
          </template>
          <template v-else-if="!searchStatus.isSearchDone">
            <div class="blank-img empty"></div>
            <div class="blank-title">{{$t('cos.tips.empty_folder')}}</div>
            <!-- <div class="blank-help">{{$t('cos.tips.drag_here')}}</div> -->
          </template>
        </template>
      </template>
    </div>

    <div class="grid-footer text-center">
      <span class="text-overflow">
        <slot name="footer"></slot>
      </span>
    </div>

    <file-dropmenu :show.sync="dropmenuShow" :position="dropmenuPosition" :options="dropmenuOptions" :action="action"
      @on-action="onAction">
    </file-dropmenu>
    <context-menu :show.sync="contextMenuShow" :position="contextMenuPosition"
      @on-action="onAction($event, 'contextmenu')"></context-menu>
  </div>
</template>

<script>
import $ from 'jquery';
import { config } from '@/scripts/tools/config';
import {
  getInnerProps,
  isAllowPreviewImageKey, isAllowPreviewVideoKey, isAllowPreviewAudioKey,
} from '@/scripts/tools/utils';
import eventProxy from '@/scripts/tools/eventProxy';

import fileDropmenu from '@/components/common/fileDropmenu.vue';
import contextMenu from '@/components/common/contextMenu.vue';

export default {
  components: {
    fileDropmenu,
    contextMenu,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    selectedList: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
    searchStatus: {
      type: Object,
      required: true,
    },
    hasAuthority: {
      type: Boolean,
      required: true,
      default: true,
    },
    currPage: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    allowCAS: Boolean,
  },
  data() {
    return {
      gridBodyHeight: 369,
      // 全选
      selectAll: false,
      selectSome: false,
      contextMenuShow: false,
      contextMenuPosition: {},
      // action 变量用来给 dropmenu 组件判断，将 click-outside 忽略打开菜单的操作按钮
      // (即将该操作按钮不视为点击元素外部)
      action: '',
      hoverIndex: -1,
      dropmenuAction: '', // dropmenu 组件的动作
      dropmenuShow: false,
      dropmenuPosition: {},
      dropmenuOptions: {},
      halfTableTop: 0,
      fileBody: null,
    };
  },
  computed: {
    gridBodyStyle() {
      const height = Math.max(369, this.gridBodyHeight);
      return {
        height: `${height}px`,
        minHeight: `${height}px`,
        maxHeight: `${height}px`,
        'overflow-x': 'hidden',
        'overflow-y': 'auto',
      };
    },
    innerList() {
      // 筛选出总列表
      const totalList = this.list;
      // 计算总大小和当前页码
      const totalNum = totalList.length;
      // 找出要显示的列表
      const start = (this.currPage - 1) * this.pageSize;
      const end = Math.min(totalNum, start + this.pageSize);
      let pageList = totalList.slice(start, end);
      // 排序
      pageList = pageList.sort((a, b) => {
        let com = 0;
        if (a.isDir !== b.isDir) {
          com = a.isDir ? -1 : 1;
        } else {
          com = a.name > b.name ? 1 : -1;
        }
        return com;
      });
      return pageList || [];
    },
    innerListMap() {
      // 对当前页显示的列表标记选中
      const listMap = {};
      this.innerList.forEach(item => {
        listMap[item.name] = true;
      });
      return listMap;
    },
    innerSelectedList: getInnerProps('selectedList'),
    innerSelectedMap() {
      // 对显示的列表标记选中
      const selectMap = {};
      this.selectedList.forEach(item => {
        selectMap[item.name] = true;
      });
      return selectMap;
    },
    selectAllButton() {
      // 获取当前页选中列表
      const currSelectedList = this.innerList.filter(
        item => this.innerSelectedMap[item.name],
      );
      const selectedListLen = currSelectedList.length;
      const listLen = this.innerList.length;

      const all = selectedListLen > 0 && selectedListLen === listLen;
      const some = selectedListLen > 0 && selectedListLen !== listLen;
      return { all, some };
    },
    actionProxy: {
      get() {
        return {
          action: this.dropmenuAction,
          item: this.item,
        };
      },
      set(val) {
        this.$emit('on-action', val);
      },
    },
    searchBarExist() {
      return this.searchStatus.isSearching || this.searchStatus.isSearchDone;
    },
  },
  watch: {
    searchBarExist() {
      this.renderGridHeight();
    },
  },
  mounted() {
    // eventProxy.on('command.select-all', this.onSelectAll);

    this.$nextTick(() => {
      this.fileBody = $('.grid-body');
      this.getHalfTableTop();
      this.fileBody.on('scroll', this.onTableScroll);
      this.renderGridHeight();
    });
    eventProxy.on('winResize', this.renderGridHeight);

    this.renderGridHeight();
  },
  beforeDestroy() {
    // eventProxy.off('command.select-all', this.onSelectAll);
    if (this.fileBody) {
      this.fileBody.off('scroll', this.onTableScroll);
    }
    eventProxy.off('winResize', this.renderGridHeight);
  },
  methods: {
    // 获取表格中间相对窗口的高度
    getHalfTableTop() {
      const gridBody = this.fileBody;
      const halfTableHeight = gridBody.height() / 2;
      const tableFixedBodyTop = gridBody.offset().top;
      this.halfTableTop = halfTableHeight + tableFixedBodyTop;
    },
    // 为表格绑定滚动事件
    onTableScroll() {
      this.$emit('on-scroll');
      if (this.dropmenuShow) {
        this.dropmenuShow = false;
      }
      if (this.contextMenuShow) {
        this.contextMenuShow = false;
      }
    },
    renderGridHeight() {
      const headerHeight = 97;
      const offsetTop = 140;
      const padding = 40;
      const { clientHeight } = document.documentElement;
      const pagination = 50;
      const searchBarHeight = this.searchBarExist ? 0 : 28;
      const tableHeight = clientHeight
        - offsetTop
        - headerHeight
        - padding
        - pagination
        + searchBarHeight;
      this.gridBodyHeight = tableHeight;
    },
    onClickOutside(e) {
      const $path = $(e.target).parents().add(e.target);
      const isContextMenu = $path.hasClass('context-menu-content');
      if (isContextMenu) return;

      const isDropmenuContent = $path.hasClass('custom-dropdown-menu');
      if (isDropmenuContent) return;

      // 点击非网格区域则初始化dropmenu所需变量
      this.action = '';
      this.dropmenuShow = false;
    },
    onEventActions(e) {
      const { index, action } = e.target.dataset;

      this.action = action || '';
      if (action) {
        this.selectedItem = this.list[index];
        switch (action) {
          case 'dropmenu': {
            const { target } = e;
            this.openDropmenu(target);
            break;
          }
          default:
            this.onAction(action);
            break;
        }
      }
    },
    onAction(action, flag) {
      const val = { item: this.selectedItem, action };
      if (flag === 'contextmenu') {
        if (this.innerSelectedList.length > 1) {
          delete val.item;
        } else {
          [val.item] = this.innerSelectedList;
        }
      }
      this.actionProxy = val;
    },
    openDropmenu(target) {
      const item = this.selectedItem;
      // 判断是否允许打开预览
      let previewType = '';
      if (isAllowPreviewImageKey(item.key)) {
        previewType = 'image';
      } else if (isAllowPreviewVideoKey(item.key)) {
        previewType = 'video';
      } else if (isAllowPreviewAudioKey(item.key)) {
        previewType = 'audio';
      }
      const allowPreview = !!previewType;
      this.dropmenuOptions = {
        allowDetail: !item.isDir,
        allowPreview: !item.isDir && allowPreview,
        previewType, // 预览选项
        allowShare: !item.isDir,
        allowRename: !item.isDir && !item.StorageClass.includes('ARCHIVE'),
        allowDownload: !item.isDir,
      };
      let dropmenuItemsNum = config.fileDesktopDropmenuNum;
      Object.keys(this.dropmenuOptions).forEach(key => {
        const value = this.dropmenuOptions[key];
        if (typeof value === 'boolean' && !value) {
          dropmenuItemsNum--;
        }
      });
      const targetOffset = $(target).offset();
      const [targetX, targetY] = [targetOffset.left, targetOffset.top];
      const [targetW, targetH] = [target.clientWidth, target.clientHeight];

      const dropmenuH = 30 * dropmenuItemsNum;
      const dropmenuW = this.$store.localeLanguage === 'zh' ? 100 : 176.5;

      let left = targetX + targetW - dropmenuW;
      if (left < 0) {
        left = targetX + targetW - 16;
      }

      // 下拉菜单的展开方向
      const dropdownDirection = targetY - this.halfTableTop <= 0 ? 'down' : 'up';
      const top = dropdownDirection === 'down'
        ? targetY + targetH + 5
        : targetY - dropmenuH - 5;

      this.dropmenuPosition = { left, top };
      this.dropmenuShow = true;
    },
    onSelectChange(item) {
      let { selectedList } = this;
      if (!item.checked) {
        item.checked = true;
        selectedList.push(item);
        this.innerSelectedList = selectedList;
      } else {
        item.checked = false;
        selectedList = selectedList.filter(v => v.checked);
        this.innerSelectedList = selectedList;
      }
    },
    onSelectAll() {
      this.changeCheckAll(true);
    },
    changeCheckAll(isCheck) {
      if (isCheck) {
        const selectedList = [...this.innerSelectedList, ...this.innerList];
        this.innerSelectedList = this.deduplication(selectedList).map(
          item => {
            item.checked = true;
            return item;
          },
        );
      } else {
        this.innerSelectedList = this.innerSelectedList
          .map(item => {
            item.checked = false;
            return item;
          })
          .filter(item => item.checked);
      }
    },
    itemRightClick(item, index, e) {
      this.contextMenuShow = true;
      this.contextMenuPosition = { x: e.clientX, y: e.clientY };
      this.dropmenuShow = false;

      const itemInSelectedList = this.innerSelectedList.filter(
        selectedItem => selectedItem.name === item.name,
      );
      if (itemInSelectedList.length === 0) {
        this.innerSelectedList.forEach(m => {
          m.checked = false;
        });
        this.innerSelectedList = [item];
      } else {
        const selectedList = [...this.innerSelectedList, item];
        this.innerSelectedList = this.deduplication(selectedList);
      }
    },
    itemDblClick(item) {
      this.innerSelectedList = [item];
      this.$emit('on-item-dblclick', item);
    },
    deduplication(list) {
      // 从后往前去重
      let index = list.length - 1;
      const hasNodeId = {};
      const deleteKey = [];
      while (index >= 0) {
        const { name } = list[index];
        if (hasNodeId[name]) {
          list.splice(index, 1);
          deleteKey.push(name);
        }
        hasNodeId[name] = true;
        index--;
      }
      return list;
    },
  },
};
</script>

<style scoped lang="scss">
.custom-dropdown {
  position: absolute;
  right: 8px;
  top: 0;
  min-width: 0;
}
.previewUrl {
  background-size: cover;
  background-position: center center;
}
.grid-header {
  height: 41px;
}
// 遵循视觉稿
.grid-body {
  padding: 10px;
  .tc-g {
    margin-top: -5px;
    margin-left: -5px;
  }
  .finder-item {
    float: left;
    width: 108px;
    padding: 0;
    margin: 4px;
  }
}
</style>
